exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-profile .card[data-v-6afc6020] {\n\tmin-height: 190px;\n}\n", ""]);

// exports
